import React from 'react';
import {Form} from "react-bootstrap";

// CSS Files
import './InputTextArea.css';

const InputTextArea = (props) => {
   return (
      <Form.Group className={props.className}>
         {props.text &&
            <Form.Label className={props.labelClasses} htmlFor={props.id}>{props.text}</Form.Label>
         }
         <Form.Control as="textarea" name={props.name} placeholder={props.placeholder} onChange={props.handleChange} defaultValue={props.defaultValue} id={props.id} rows={props.rows}/>
      </Form.Group>
   )
}

export default InputTextArea;